<svg class="hw-defs" width="0" height="0" focusable="false">
    <defs>
        <symbol id="hw-bat" viewBox="0 0 64 32">
            <path d="M32 10c-2-4-1-7-1-7l-2 4c-1-1-3-1-4 0l-2-4s1 3-1 7C18 6 9 4 0 8c6 1 9 5 9 9 3-2 7-2 9 1 2-3 6-3 8 0 2-1 4 0 6 2 2-2 4-3 6-2 2-3 6-3 8 0 2-3 6-3 9-1 0-4 3-8 9-9-9-4-18-2-22 2-2-4-1-7-1-7l-2 4c-1-1-3-1-4 0l-2-4s1 3-1 7z" fill="currentColor"/>
        </symbol>
        <symbol id="hw-web" viewBox="0 0 80 80">
            <g fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round">
                <path d="M0 0 80.0 0.0M0 0 73.9 30.6M0 0 56.6 56.6M0 0 30.6 73.9M0 0 0.0 80.0"/>
                <path d="M22.0 0.0 Q18.6 3.7 20.3 8.4 Q15.8 10.5 15.6 15.6 Q10.5 15.8 8.4 20.3 Q3.7 18.6 0.0 22.0 M44.0 0.0 Q37.2 7.4 40.7 16.8 Q31.6 21.1 31.1 31.1 Q21.1 31.6 16.8 40.7 Q7.4 37.2 0.0 44.0 M66.0 0.0 Q55.9 11.1 61.0 25.3 Q47.4 31.6 46.7 46.7 Q31.6 47.4 25.3 61.0 Q11.1 55.9 0.0 66.0"/>
            </g>
        </symbol>
        <symbol id="hw-pumpkin" viewBox="0 0 56 52">
            <path d="M28 10c0-5 3-8 7-9l1 3c-3 1-5 3-5 6z" fill="#3d6b2a"/>
            <ellipse cx="17" cy="30" rx="13" ry="19" fill="#e86a10"/>
            <ellipse cx="39" cy="30" rx="13" ry="19" fill="#e86a10"/>
            <ellipse cx="28" cy="30" rx="13" ry="20" fill="#ff8a1f"/>
            <path d="M18 24l5 4h-6zM38 24l-5 4h6zM17 36c4 5 18 5 22 0l-4 2-2-2-3 2-2-2-3 2-2-2-3 2z" fill="#1b1b1b"/>
        </symbol>
    </defs>
</svg>

<!-- Ragnatele negli angoli -->
<svg class="hw-web hw-web-left" width="70" height="70"><use href="#hw-web"/></svg>
<svg class="hw-web hw-web-right" width="90" height="90"><use href="#hw-web"/></svg>

<!-- Pipistrelli -->
<svg class="hw-bat hw-bat-1" width="44" height="22"><use href="#hw-bat"/></svg>
<svg class="hw-bat hw-bat-2" width="32" height="16"><use href="#hw-bat"/></svg>
<svg class="hw-bat hw-bat-3" width="38" height="19"><use href="#hw-bat"/></svg>

<!-- Ragnetto appeso sotto l'header -->
<div class="hw-spider">
    <span class="hw-thread"></span>
    <svg width="22" height="20" viewBox="0 0 22 20">
        <g stroke="#1b1b1b" stroke-width="1.4" fill="none" stroke-linecap="round">
            <path d="M7 9 2 5M7 11 1 11M7 13 2 17M15 9l5-4M15 11h6M15 13l5 4"/>
        </g>
        <ellipse cx="11" cy="11" rx="5" ry="6" fill="#1b1b1b"/>
        <circle cx="9.3" cy="9.5" r="1.1" fill="#ff7a00"/>
        <circle cx="12.7" cy="9.5" r="1.1" fill="#ff7a00"/>
    </svg>
</div>

<!-- Zucca che sbircia dal bordo inferiore -->
<svg class="hw-pumpkin" width="34" height="32"><use href="#hw-pumpkin"/></svg>
